import { ExternalAccountKind } from '../constants/organizationRelationshipKind'

export type OrganizationExternalModeFlags = {
  isPromoter: boolean
  isPartner: boolean
}

export type OrganizationExternalModeInput = {
  accountKind?: ExternalAccountKind | null
  isPromoter?: boolean | null
  subscriptionActive?: boolean | null
}

const defaultExternalModeFlags: OrganizationExternalModeFlags = {
  isPromoter: false,
  isPartner: false,
}

export function getOrganizationExternalModeFlags(
  organization?: OrganizationExternalModeInput | null
): OrganizationExternalModeFlags {
  if (!organization) return defaultExternalModeFlags

  if (organization.accountKind === ExternalAccountKind.PARTNER) {
    return {
      isPartner: true,
      isPromoter: false,
    }
  }

  if (organization.accountKind === ExternalAccountKind.PROMOTER) {
    return {
      isPartner: false,
      isPromoter: true,
    }
  }

  return {
    isPartner: false,
    isPromoter: organization.isPromoter === true,
  }
}

export function getPostHogOrganizationSessionProperties(
  organization?:
    | (OrganizationExternalModeInput & {
        id?: string
        name?: string | null
      })
    | null
): {
  organization_id: string | null
  organization_name: string | null
  organization_subscription_active: boolean | null
  is_promoter: boolean
  is_partner: boolean
} {
  const { isPromoter, isPartner } =
    getOrganizationExternalModeFlags(organization)

  return {
    organization_id: organization?.id ?? null,
    organization_name: organization?.name ?? null,
    organization_subscription_active:
      typeof organization?.subscriptionActive === 'boolean'
        ? organization.subscriptionActive
        : null,
    is_promoter: isPromoter,
    is_partner: isPartner,
  }
}

export function getPostHogOrganizationGroupProperties(
  organization?:
    | (OrganizationExternalModeInput & {
        id?: string
        name?: string | null
      })
    | null
): {
  organizationId?: string
  name?: string
  isPromoter: boolean
  isPartner: boolean
  accountKind?: ExternalAccountKind
  subscriptionActive?: boolean
} {
  const { isPromoter, isPartner } =
    getOrganizationExternalModeFlags(organization)

  return {
    organizationId:
      organization?.id != null ? String(organization.id) : undefined,
    name: organization?.name ?? undefined,
    isPromoter,
    isPartner,
    accountKind: organization?.accountKind ?? undefined,
    subscriptionActive:
      typeof organization?.subscriptionActive === 'boolean'
        ? organization.subscriptionActive
        : undefined,
  }
}
